import { gql, TypedDocumentNode } from '@apollo/client'

import { AdUnitRefresherDTO } from 'features/inventory/api/types/adUnitRefresherDTO'

export const AD_UNIT_REFRESHER_FRAGMENT: TypedDocumentNode<AdUnitRefresherDTO> = gql`
  fragment AdUnitRefresherFragment on AdUnitRefresher {
    adUnitId
    customizeRefresherBasicSettingsEnabled
    desktopAdThreshold
    desktopMonitorUserScrollEnabled
    desktopRefreshInterval
    id
    mobileAdThreshold
    mobileMonitorUserScrollEnabled
    mobileRefreshInterval
    refresherEnabled
    updatedAt
  }
`
